<template>
  <div>
    <v-card class="ma-3 px-3 py-2">
      <v-layout row class="mb-2">
        <div class="font-weight-medium mb-2 mt-0 pt-3 headline mr-3">
          Routes Report
        </div>

        <v-btn-toggle
          @change="reportModeChanged"
          mandatory
          v-model="reportMode"
          class="toggle-button-group ml-0 mt-3"
          style="height: 29px;"
        >
          <v-btn
            flat
            value="Default"
            class="toggle-button default-report-button"
          >
            Default
          </v-btn>
          <v-btn flat value="Date" class="toggle-button date-report-button">
            By Date
          </v-btn>
        </v-btn-toggle>

        <v-menu v-if="reportMode == 'Date'" v-model="datePickerMenu" offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="reportDate"
              label="Date"
              prepend-icon="mdi-calendar"
              readonly
              hide-details
              class="mb-0 ml-3 mr-1"
              style="max-width: 200px;"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="reportDate"
            @change="loadReport()"
          ></v-date-picker>
        </v-menu>
        <v-btn
          small
          class="mt-3 ml-3"
          :loading="downloading"
          color="success"
          @click="downloadPDF"
          >Download Report</v-btn
        >
        <v-spacer></v-spacer>
        <v-select
          class="pt-3"
          v-model="season"
          label="Season"
          :items="seasons"
          hide-details
          style="max-width: 200px;"
          @change="seasonChanged"
        ></v-select>
        <v-select
          class="ml-2 pt-3"
          v-model="term"
          label="Term"
          :items="terms"
          hide-details
          style="max-width: 150px;"
          @change="loadReport"
        ></v-select>
      </v-layout>

      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
        color="success"
      ></v-progress-linear>

      <div style="overflow-x: auto;" ref="report" v-if="!loading">
        <div v-for="group in routeGroupTypes" :key="group">
          <table class="routes-report">
            <colgroup>
              <col
                :class="{
                  'group-column': group != 'CUSTOM',
                  'custom-group-column': group == 'CUSTOM',
                }"
              />
              <col class="route-id-column" />
              <col class="grades-column" />
              <col class="bus-column" v-for="bus in buses" :key="bus" />
            </colgroup>
            <tr style="background-color: black; color: yellow;">
              <th
                v-bind:class="{
                  'group-column': group != 'CUSTOM',
                  'custom-group-column': group == 'CUSTOM',
                }"
              >
                {{ group }}
              </th>
              <th class="route-id-column">Route ID</th>
              <th class="grades-column">Grades</th>
              <th class="bus-column" v-for="bus in buses" :key="bus">
                {{ bus }}
              </th>
            </tr>
            <tr
              v-for="route in routeGroups.filter((r) => r.groupBy == group)"
              :key="route.id"
            >
              <td
                class="ht"
                v-bind:class="{
                  'group-column': group != 'CUSTOM',
                  'custom-group-column': group == 'CUSTOM',
                  'small-text':
                    (
                      route.timeStart +
                      (group == 'CUSTOM'
                        ? ' (' + (route.weekDays || '') + ')'
                        : '')
                    ).length > 12,
                }"
                style="background-color: rgb(221 183 150)"
                :title="
                  route.timeStart +
                    (group == 'CUSTOM'
                      ? ' (' + (route.weekDays || '') + ')'
                      : '')
                "
              >
                {{
                  route.timeStart +
                    (group == "CUSTOM"
                      ? " (" + (route.weekDays || "") + ")"
                      : "")
                }}
              </td>
              <td
                class="route-id-column"
                style="background-color: rgb(221 183 150)"
                :title="route.routeIdentifier || ''"
                :class="{
                  'small-text':
                    route.routeIdentifier && route.routeIdentifier.length > 18,
                }"
              >
                {{ route.routeIdentifier }}
              </td>
              <td
                class="grades-column"
                style="background-color: rgb(221 183 150)"
                :title="route.grades || ''"
                :class="{
                  'small-text': route.grades && route.grades.length > 25,
                }"
              >
                {{ route.grades }}
              </td>
              <td
                class="bus-column"
                style="cursor: pointer;"
                v-bind:class="{
                  'active-custom-route':
                    group == 'CUSTOM' && hasBusRoute(route, bus),
                  'active-route': group != 'CUSTOM' && hasBusRoute(route, bus),
                  'active-girl-route':
                    group != 'CUSTOM' && hasGirlBusRoute(route, bus),
                  'is-absent': hasAbsent(route, bus),
                  'is-absent-sub': hasAbsentSub(route, bus),
                  'small-text':
                    hasBusRoute(route, bus) &&
                    getRouteText(route, bus) &&
                    getRouteText(route, bus).length > 8,
                }"
                v-for="bus in buses"
                :key="bus"
                @click="onCellClicked(route, bus)"
                :title="hasBusRoute(route, bus) ? getRouteText(route, bus) : ''"
              >
                <template v-if="hasBusRoute(route, bus)">
                  {{ getRouteText(route, bus) }}
                </template>
              </td>
            </tr>
          </table>
        </div>

        <!-- <table class="routes-report">
                    <tr style="background-color: black; color: yellow;">
                        <th style="min-width: 90px">PM</th>
                        <th style="min-width: 200px">Route ID</th>
                        <th style="min-width: 200px">Grades</th>
                        <th style="min-width: 50px" v-for="bus in buses">
                            {{ bus }}
                        </th>
                    </tr>
                    <tr
                        v-for="route in routeGroups.filter(
                            (r) => r.groupBy == 'PM',
                        )"
                        :key="route.id"
                    >
                        <td
                            style="min-width: 90px; background-color: rgb(221 183 150)"
                        >
                            {{ route.timeStart }}
                        </td>
                        <td
                            style="min-width: 200px; background-color: rgb(221 183 150)"
                            :title="route.routeIdentifier"
                        >
                            {{ truncateText(route.routeIdentifier) }}
                        </td>
                        <td
                            style="min-width: 200px; background-color: rgb(221 183 150)"
                        >
                            {{ route.grades }}
                        </td>
                        <td
                            style="min-width: 50px; cursor: pointer;"
                            v-bind:class="{
                                'active-route': hasBusRoute(route, bus),
                                'active-girl-route': hasGirlBusRoute(
                                    route,
                                    bus,
                                ),
                                'is-absent': hasAbsent(route, bus),
                                'is-absent-sub': hasAbsentSub(route, bus),
                            }"
                            v-for="bus in buses"
                            @click="onCellClicked(route, bus)"
                        >
                            <template v-if="hasBusRoute(route, bus)">
                                {{ getRouteText(route, bus) }}
                            </template>
                        </td>
                    </tr>
                </table>

                <table class="routes-report">
                    <tr style="background-color: black; color: yellow;">
                        <th style="min-width: 200px">Custom</th>
                        <th style="min-width: 200px">Route ID</th>
                        <th style="min-width: 200px">Grades</th>
                        <th style="min-width: 50px" v-for="bus in buses">
                            {{ bus }}
                        </th>
                    </tr>
                    <tr
                        v-for="route in routeGroups.filter(
                            (r) => r.groupBy == 'CUSTOM',
                        )"
                        :key="route.id"
                    >
                        <td
                            style="min-width: 200px; background-color: rgb(221 183 150)"
                        >
                            {{ route.timeStart + " (" + route.weekDays + ")" }}
                        </td>
                        <td
                            style="min-width: 200px; background-color: rgb(221 183 150)"
                            :title="route.routeIdentifier"
                        >
                            {{ truncateText(route.routeIdentifier) }}
                        </td>
                        <td
                            style="min-width: 200px; background-color: rgb(221 183 150)"
                        >
                            {{ route.grades }}
                        </td>
                        <td
                            style="min-width: 50px; cursor: pointer;"
                            v-bind:class="{
                                'active-custom-route': hasBusRoute(route, bus),
                                'is-absent': hasAbsent(route, bus),
                                'is-absent-sub': hasAbsentSub(route, bus),
                            }"
                            v-for="bus in buses"
                            @click="onCellClicked(route, bus)"
                        >
                            <template v-if="hasBusRoute(route, bus)">
                                {{ getRouteText(route, bus) }}
                            </template>
                        </td>
                    </tr>
                </table> -->
      </div>
    </v-card>

    <v-dialog persistent v-model="updateRouteDialog" max-width="1000">
      <update-route
        ref="updateRouteDialog"
        :rowClicked="routeClicked"
        :driver_busList="driver_busList"
        :loadRouteSchedules="loadRouteSchedules"
        :reloadGrid="loadReport"
        :terms="terms"
        :buildingList="buildingList"
        :gradeList="gradeList"
        :closeUpdateRouteDialog="closeUpdateRouteDialog"
      ></update-route>
    </v-dialog>

    <v-dialog persistent v-model="updateAbsentReportDialog" max-width="900">
      <update-absent
        :absent="absentClicked"
        :reload="loadReport"
        :closeAbsentReportDialog="closeAbsentReportDialog"
      ></update-absent>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import crosstab from "vue-crosstab";
import {
  groupBy,
  getDomain,
  onlyUnique,
  toISOLocal,
  truncate,
} from "../../utils/helpers.js";
import DxDateBox from "devextreme-vue/date-box";
import axios from "axios";
import updateAbsent from "./UpdateAbsent.vue";
import UpdateRoute from "./UpdateRoute.vue";

export default {
  components: {
    crosstab,
    DxDateBox,
    updateAbsent,
    UpdateRoute,
  },
  data: () => ({
    title: "Routes Report",

    routes: [],
    routeGroups: [],

    buses: [],
    allRouteGroupTypes: ["FAM", "AM", "PM", "PPM", "CUSTOM"],
    routeGroupTypes: ["FAM", "AM", "PM", "PPM", "CUSTOM"],

    downloading: false,
    loading: false,
    processing: false,

    datePickerMenu: false,
    reportMode: "Default",
    reportDate: toISOLocal(new Date(moment())).substr(0, 10),

    defaultWeekDays: "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday",

    weekDayList: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
    ],

    updateRouteDialog: false,

    terms: [],
    term: "",
    seasons: [],
    season: "",
    buildingList: [],
    gradeList: [],
    driver_busList: [],

    routeClicked: {
      id: "",
      term: "",
      season: "",
      timeStart: "",
      direction: "",
      buildings: [],
      grades: [],
      description: "",
      color: "",
      notes: "",
      weekDays: [],
      routeSchedules: [],
    },

    updateAbsentReportDialog: false,
    absentClicked: {
      driver: "",
      busNumber: "",
      timeStart: "",
      buildings: "",
      grades: "",
      datePickerMenu: false,
      date: "",
    },

    absents: [],

    updateAbsentReport: {
      selectedSubDriver: "",
      isUpdatingSubDriversList: false,
      subDriversDisplayList: [],
      subDrivers: [],
      subDriverListFilter: "all",
    },

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
      busDriverRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateFrom ||
          !routeSchedule.type ||
          !!value ||
          "Required."
        );
      },
      routeScheduleTypeRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateFrom ||
          !routeSchedule.driver_bus ||
          !!value ||
          "Required."
        );
      },
    },
  }),
  watch: {},
  mounted() {},
  beforeDestroy() {},
  async created() {
    await this.loadRegID();
    await this.loadSeason();
    await this.loadReport();

    this.loadBuildings();
    this.loadGrades();
    this.loadDriverBusList();
    this.loadTerms();
    this.loadSeasons();
  },
  methods: {
    async loadReport() {
      this.loading = true;

      const date =
        this.reportMode == "Date"
          ? moment(this.reportDate).format("YYYY-MM-DD HH:mm:ss")
          : null;

      try {
        const response = await this.$http.get(
          `api/route/getRoutesReport?regID=${this.term}&season=${
            this.season
          }&date=` + date
        );

        this.routeGroups = response;

        this.buses = this.routeGroups
          .map((r) => r.routeSchedules)
          .flat()
          .map((r) => r.busNumber)
          .filter(onlyUnique)
          .sort();

        this.routeGroupTypes = this.allRouteGroupTypes.filter((t) =>
          this.routeGroups
            .map((r) => r.groupBy)
            .flat()
            .includes(t)
        );

        this.loading = false;

        if (date) {
          this.absents = await this.$http.get(
            "api/driverAbsent/getByDate?date=" + date
          );
        }

        this.$forceUpdate();
      } catch (e) {
        this.loading = false;
      }
    },
    async loadBuildings() {
      const response = await this.$http.get("api/students/getBuildingList");

      response.push("Queens");
      response.push("741");

      this.buildingList = response.sort();
    },
    async loadGrades() {
      const response = await this.$http.get("api/students/getGradeList");

      response.push("YG");

      this.gradeList = response.sort();
    },
    async loadTerms() {
      const terms = await this.$http.get("api/allStudents/getRegTerms");

      this.terms = terms;
    },
    async loadRegID() {
      const regID = await this.$http.get("api/allStudents/getRegID");

      this.term = regID;
    },
    async loadSeasons() {
      const seasons = await this.$http.get("api/route/getRouteSeasons");

      this.seasons = seasons.map((s) => s.season);
    },
    async loadSeason() {
      const season = localStorage.getItem("route-season");

      this.season = season ? season : this.seasons[0];
    },
    seasonChanged(value) {
      localStorage.setItem("route-season", value);

      this.loadReport();
    },
    async loadDriverBusList() {
      const response = await this.$http.get("api/route/getDriverBusList");

      this.driver_busList = response
        .map((driverBus) => {
          driverBus.displayName =
            (driverBus.nameH ? driverBus.nameH : driverBus.name) +
            " - " +
            driverBus.busNumber;

          return driverBus;
        })
        .sort((a, b) => {
          const busNumberA = parseInt(a.busNumber) || 0;
          const busNumberB = parseInt(b.busNumber) || 0;
          return busNumberA - busNumberB;
        });
    },
    closeUpdateRouteDialog() {
      this.updateRouteDialog = false;
    },
    async onCellClicked(clickedRoute, bus) {
      if (this.hasAbsent(clickedRoute, bus)) {
        return this.onAbsentCellClicked(clickedRoute, bus);
      }

      const routeData = clickedRoute.routeSchedules.find(
        (r) => r.busNumber == bus
      );

      const response = await this.$http.get(
        `/odata/route?regID=${this.term}&season=${
          this.season
        }&filterByToday=&$filter=(id eq ${routeData.route_ID})`
      );

      const route = response.value[0];

      const routeClicked = JSON.parse(JSON.stringify(route));

      routeClicked.buildings = routeClicked.buildings
        ? routeClicked.buildings.split(",")
        : [];
      routeClicked.grades = routeClicked.grades
        ? routeClicked.grades.split(",")
        : [];
      routeClicked.weekDays = routeClicked.weekDays
        ? routeClicked.weekDays.split(",")
        : [];

      let splitTime = routeClicked.timeStart.split(":"); //splitTime = ['06', '10 AM']
      let hour = parseInt(splitTime[0]); //Convert '06' to integer
      let minutes = parseInt(splitTime[1].split(" ")[0]); //Convert '10 AM' to integer

      if (splitTime[1].split(" ")[1] === "PM") {
        //If it is, add 12 hours to the hour variable
        hour += 12;
      }

      const currentDateTime = new Date();

      currentDateTime.setHours(hour);
      currentDateTime.setMinutes(minutes);

      routeClicked.timeStart = currentDateTime;

      const routeSchedules = await this.$http.get(
        "api/route/getRouteSchedules?routeID=" + routeClicked.id
      );

      routeClicked.routeSchedules = routeSchedules.map((routeSchedule) => {
        const driver_bus = this.driver_busList.find(
          (d) => d.id == routeSchedule.driver_Bus_ID
        );

        routeSchedule.driver_bus = driver_bus ? driver_bus.displayName : "";

        (routeSchedule.dateFrom = routeSchedule.dateFrom
          ? toISOLocal(new Date(routeSchedule.dateFrom)).substr(0, 10)
          : ""),
          (routeSchedule.dateTo = routeSchedule.dateTo
            ? toISOLocal(new Date(routeSchedule.dateTo)).substr(0, 10)
            : ""),
          (routeSchedule.dateToPickerMenu = false);
        routeSchedule.dateFromPickerMenu = false;

        return routeSchedule;
      });

      // if (!this.routeClicked.routeSchedules.length) {
      //     this.addRouteSchedule();
      // }

      this.routeClicked = routeClicked;

      this.updateRouteDialog = true;
    },
    async onAbsentCellClicked(clickedRoute, bus) {
      const routeData = clickedRoute.routeSchedules.find(
        (r) => r.busNumber == bus
      );

      const absentData = await this.$http.get(
        "api/driverAbsent/GetByRouteIdAndDate?routeID=" +
          routeData.route_ID +
          "&date=" +
          moment(this.reportDate).format("L")
      );

      this.absentClicked = JSON.parse(JSON.stringify(absentData));

      this.updateAbsentReportDialog = true;
    },
    closeAbsentReportDialog() {
      this.updateAbsentReportDialog = false;
    },
    async loadRouteSchedules(routeClicked) {
      const response = await this.$http.get(
        "api/route/getRouteSchedules?routeID=" +
          (routeClicked ? routeClicked.id : this.routeClicked.id)
      );

      const routeSchedules = response.map((routeSchedule) => {
        const driver_bus = this.driver_busList.find(
          (d) => d.id == routeSchedule.driver_Bus_ID
        );

        routeSchedule.driver_bus = driver_bus ? driver_bus.displayName : "";

        (routeSchedule.dateFrom = routeSchedule.dateFrom
          ? toISOLocal(new Date(routeSchedule.dateFrom)).substr(0, 10)
          : ""),
          (routeSchedule.dateTo = routeSchedule.dateTo
            ? toISOLocal(new Date(routeSchedule.dateTo)).substr(0, 10)
            : ""),
          (routeSchedule.dateToPickerMenu = false);
        routeSchedule.dateFromPickerMenu = false;

        return routeSchedule;
      });

      if (routeClicked) {
        routeClicked.routeSchedules = routeSchedules;
      } else {
        this.routeClicked.routeSchedules = routeSchedules;
      }
    },
    subDriverListFilterChanged(value) {
      this.updateAbsentReport.subDriversDisplayList =
        value == "all"
          ? this.updateAbsentReport.subDrivers
          : this.updateAbsentReport.subDrivers.filter(
              (s) => s.group == "Not Occupied"
            );
    },
    removeSubDriver(item) {
      this.updateAbsentReport.selectedSubDriver = "";
    },
    async deleteReport() {
      try {
        this.processing = true;

        await this.$http.post("api/driverAbsent/delete", [
          this.absentClicked.id,
        ]);

        this.processing = false;
        this.updateAbsentReportDialog = false;

        this.$notify({
          group: "notification",
          text: "Absent Report Deleted",
          type: "success",
        });

        this.loadReport();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveAbsentReport() {
      if (!this.absentClicked.date) {
        return this.$notify({
          text: "Date is required",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const subDriver = this.updateAbsentReport.subDrivers.find(
          (sd) => sd.id == this.updateAbsentReport.selectedSubDriver
        );

        await this.$http.post("api/driverAbsent/save", [
          {
            id: this.absentClicked.id,
            driver_Bus_ID: this.absentClicked.driver_Bus_ID,
            route_ID: this.absentClicked.route_ID,
            date: this.absentClicked.date,
            subDriver_Bus_ID: subDriver ? subDriver.id : null,
          },
        ]);

        this.processing = false;
        this.updateAbsentReportDialog = false;

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.loadReport();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    addRouteSchedule() {
      this.routeClicked.routeSchedules.push({
        driver_bus: "",
        type: "Default",
        dateFromPickerMenu: false,
        dateFrom: "",
        dateToPickerMenu: false,
        dateTo: "",
      });

      this.$forceUpdate();
    },
    removeRouteSchedule(index) {
      if (index == 0) {
        this.routeClicked.routeSchedules[index].driver_bus = "";
        this.routeClicked.routeSchedules[index].type = "";
        this.routeClicked.routeSchedules[index].dateFrom = "";
        this.routeClicked.routeSchedules[index].dateTo = "";
      } else {
        this.routeClicked.routeSchedules.splice(index, 1);
      }

      this.$forceUpdate();
    },
    formatedDate(date) {
      return date ? moment(date).format("L") : "";
    },
    hasBusRoute(route, bus) {
      return route.routeSchedules.some((r) => r.busNumber == bus);
    },
    hasGirlBusRoute(route, bus) {
      const girlBuildings = ["241", "60H", "720"];

      const buildings = route.buildings ? route.buildings.split(",") : [];

      return (
        girlBuildings.some((gb) => buildings.includes(gb)) &&
        route.routeSchedules.some((r) => r.busNumber == bus)
      );
    },
    getRouteText(route, bus) {
      if (this.hasAbsent(route, bus)) {
        return this.hasAbsentSub(route, bus) ? "SUB" : "ABSENT";
      }

      const routeSchedule = route.routeSchedules.find(
        (r) => r.busNumber == bus
      );

      return routeSchedule.color;
      //return route.buildings;
    },
    hasAbsent(route, bus) {
      const absent = route.routeSchedules.some(
        (r) => r.busNumber == bus && r.isAbsent
      );

      return absent && route.routeSchedules.some((r) => !r.isAbsent);
    },
    hasAbsentSub(route, bus) {
      if (!this.hasAbsent(route, bus)) return;

      const routeData = route.routeSchedules.find(
        (r) => r.busNumber == bus && r.isAbsent
      );

      if (!routeData) return "ABSENT";

      const absent = this.absents.find((a) => a.route_ID == routeData.route_ID);

      return absent && absent.subDriver_Bus_ID;
    },
    reportModeChanged(value) {
      this.loadReport();
    },
    async downloadPDF() {
      // const newWindow = window.open(
      //     "",
      //     "Account Statement",
      //     "width=1600, height=1200"
      // );

      // newWindow.document.write(this.createStatement());
      let html = `<style>.routes-report {
    margin: auto;
    border-collapse: collapse;
    font-size: 15px;
    font-family: arial;
    table-layout: fixed;
    width: 100%;
}

.routes-report table,
th,
td {
    border: 1px solid black;
}

.routes-report th,
td {
    padding: 6px;
    text-align: center;
    overflow: hidden;
    word-break: break-word;
}

.routes-report tr:nth-child(even) {
    background-color: #f2f2f2;
}

.routes-report .highlight {
    background-color: yellow;
}
.custom-group-column {
    width: 90px;
    min-width: 90px;
}
.group-column {
    width: 90px;
    min-width: 90px;
}
.route-id-column {
    width: 200px;
    min-width: 200px;
}
.grades-column {
    width: 200px;
    min-width: 200px;
}
.bus-column {
    width: 70px;
    min-width: 70px;
}
.active-route {
    background-color: #afafff !important;
}
.active-girl-route {
    background-color: #ffd2e5 !important;
}
.active-custom-route {
    background-color: #8fd792 !important;
}
.is-absent {
    background-color: #ff1e1e !important;
    color: #fffda5 !important;
    font-weight: 500;
}
.is-absent-sub {
    background-color: #FFA726 !important;
    color: #fff !important;
    font-weight: 500;
}
.small-text {
    font-size: 11px !important;
    line-height: 1.2;
}
</style>`;

      html += this.$refs.report.innerHTML;

      const url = getDomain() + "/api/route/DownloadRoutes";

      this.downloading = true;

      axios({
        url: url,
        data: {
          html,
        },
        method: "POST",
        responseType: "blob", // important
      })
        .then((response) => {
          this.downloading = false;

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "RoutesReport.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.downloading = false;
        });
    },
    validate() {
      const validations = [
        this.$refs.description.validate(true),
        this.$refs.direction.validate(true),
        this.$refs.term.validate(true),
      ];

      this.$refs.driver_bus.map((driver_bus) => {
        validations.push(driver_bus.validate(true));
      });

      return validations.every(Boolean);
    },
    async saveRoute() {
      if (!this.validate()) return;

      if (
        this.routeClicked.routeSchedules.some(
          (schedule) =>
            schedule.dateFrom &&
            schedule.dateTo &&
            new Date(schedule.dateFrom) > new Date(schedule.dateTo)
        )
      ) {
        return this.$notify({
          text: "From Date is later than the To Date",
          group: "notification",
          type: "error",
        });
      }

      if (
        this.routeClicked.routeSchedules.filter(
          (schedule) => schedule.type == "Default"
        ).length > 1
      ) {
        return this.$notify({
          text: "Can't have more than 1 Default route",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const routeSchedules = this.routeClicked.routeSchedules
          .filter((r) => r.driver_bus)
          .map((schedule) => {
            const driver_bus = this.driver_busList.find(
              (d) => d.displayName == schedule.driver_bus
            );

            return {
              id: schedule.id,
              driver_Bus_ID: driver_bus.id,
              type: schedule.type,
              dateFrom: schedule.dateFrom
                ? moment(schedule.dateFrom).format("L")
                : "",
              dateTo: schedule.dateTo
                ? moment(schedule.dateTo).format("L")
                : "",
            };
          });

        await this.$http.post("api/route/save", {
          route: {
            id: this.routeClicked.id,
            term: this.routeClicked.term,
            timeStart: this.getTimeStart(this.routeClicked.timeStart),
            direction: this.routeClicked.direction,
            buildings: this.routeClicked.buildings.join(","),
            grades: this.routeClicked.grades.join(","),
            description: this.routeClicked.description,
            weekDays: this.routeClicked.weekDays.join(","),
            color: this.routeClicked.color,
            notes: this.routeClicked.notes,
            geoSchedule: this.routeClicked.geoSchedule,
          },
          routeSchedules,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.updateRouteDialog = false;
        this.processing = false;

        this.loadReport();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getTimeStart(value) {
      var date = new Date(value);
      var hour = date.getHours();
      var minutes = date.getMinutes();

      // Convert to 12-hour clock
      var period = hour >= 12 ? "PM" : "AM";
      hour = hour > 12 ? hour - 12 : hour;
      hour = hour === 0 ? 12 : hour;

      // Format minutes
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      return hour + ":" + minutes + " " + period;
    },
    truncateText(text) {
      return truncate(text, 18);
    },
    truncateGroupColumn(text, group) {
      const maxLength = 12;
      return truncate(text, maxLength);
    },
    truncateGrades(text) {
      return truncate(text || "", 25);
    },
    truncateRouteText(text) {
      if (!text) return "";
      return truncate(text, 8);
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
.routes-report {
  margin: auto;
  border-collapse: collapse;
  font-size: 15px;
  table-layout: fixed;
  width: 100%;
}

.routes-report table,
.routes-report th,
.routes-report td {
  border: 1px solid black;
}

.routes-report th,
.routes-report td {
  padding: 6px;
  text-align: center;
  overflow: hidden;
  word-break: break-word;
}

.routes-report tr:nth-child(even) {
  background-color: #f2f2f2;
}

.routes-report .highlight {
  background-color: yellow;
}
.active-route {
  background-color: #93c8ff !important;
}
.active-girl-route {
  background-color: #ffd2e5 !important;
}
.active-custom-route {
  background-color: #8fd792 !important;
}
.is-absent {
  background-color: #ff1e1e !important;
  color: #fffda5 !important;
  font-weight: 500;
}
.is-absent-sub {
  background-color: #ffa726 !important;
  color: #fff !important;
  font-weight: 500;
}
.toggle-button {
  font-size: 15px;
  padding: 5px !important;
}
.toggle-button-group {
  border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
  background-color: #afecb2 !important;
  color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.default-report-button {
  border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.date-report-button {
  border-radius: 0px 10px 10px 0px;
}
.custom-group-column {
  width: 90px;
  min-width: 90px;
}
.group-column {
  width: 90px;
  min-width: 90px;
}
.route-id-column {
  width: 200px;
  min-width: 200px;
}
.grades-column {
  width: 200px;
  min-width: 200px;
}
.bus-column {
  width: 70px;
  min-width: 70px;
}
.small-text {
  font-size: 11px !important;
  line-height: 1.2;
}
</style>
